import React, { useState } from "react";
import { Box } from "./style";
import returnNumber from "../../lib/returnNumber";

/**
 * Make float label input with warning .
 * @param {String} status
 * @param {String} icon
 * @param {String} type
 * @param {String} label
 * @param {String} notice
 */
const onlyNumberReg = new RegExp("/^\\d+$/");
export default props => {
  const [iconStatus, setIconStatus] = useState("");
  const { input, meta, id, type, icon, label, alignLeft, ...others } = props;
  const finalType = type === "currency" ? "text" : type;
  let displayedValue = input.value;
  if (type === "currency") {
    if (!onlyNumberReg.test(input.value)) {
      displayedValue = returnNumber(displayedValue);
    }
    displayedValue =
      displayedValue &&
      displayedValue !== 0 &&
      parseInt(displayedValue).toLocaleString("fa");
  }
  const labelStatus = () => {
    if (input.value && input.value.toString().length > 0) {
      return "top";
    } else {
      return "down";
    }
  };
  const formStatus = () => {
    if (meta.error) {
      return "error";
    }
  };
  const setPaddingLeft = () => {
    let res = 0;
    if (icon) {
      res = 48;
    }
    return res;
  };
  return (
    <Box
      status={formStatus()}
      iconStatus={iconStatus}
      labelStatus={labelStatus()}
      paddingLeft={alignLeft ? setPaddingLeft() : ""}
      alignLeft={alignLeft}
    >
      <input
        id={id || input.name}
        type={finalType}
        value={displayedValue}
        onChange={e => {
          let returnedValue = e.target.value;
          if (type === "currency") {
            returnedValue = returnNumber(returnedValue);
          }
          input.onChange(returnedValue);
        }}
        onFocus={() => setIconStatus("focus")}
        onBlur={() => setIconStatus("")}
        autoComplete="random"
        maxLength={input.maxLength}
        {...others}
      />
      <i className={icon} />
      <label htmlFor={id || input.name}>{label}</label>
      {meta.error && <span className="notice">{meta.error}</span>}
    </Box>
  );
};
